import { useTheme } from '@mui/material';
import { checkboxIconColors } from './checkboxIconPalette';

const CheckboxUncheckedIcon = () => {
  const { palette } = useTheme();
  const { border } = checkboxIconColors(palette);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect
        x="1"
        y="1"
        width="18"
        height="18"
        rx="3"
        stroke={border}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckboxUncheckedIcon;
